import { DetailedRoute } from '@/generated/model/detailedRoute';

export function sumDistance(routes: DetailedRoute[]) {
  const distanceSumKm: number = routes.reduce((acc, current) => acc + current.distanceKm, 0);
  return formatDistanceKm(distanceSumKm);
}

export function formatDistanceKm(distanceKm: number) {
  if (distanceKm < 1.0) {
    const distanceMeter = distanceKm * 1000;
    return `${distanceMeter} m`;
  }
  return `${distanceKm.toFixed(1)} km`;
}
